<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <div class="apart_list">
                <left></left>
                <NovelTurnScriptAdd></NovelTurnScriptAdd>
            </div>
        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import NovelTurnScriptAdd from '@/components/novelTurnScript/add.vue'

export default {
    components: {
        top, left, NovelTurnScriptAdd
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        }
    }
}
</script>

<style>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    min-width: 1500px;
}
.apart_list {
	display: flex;
	flex: 1;
}
</style>